import React from "react";
import { CBadge } from "@coreui/react";

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{ color: "white", backgroundColor: "#2bc2f7" }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const TabSwitcherComponent = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid">
      <div className="d-flex">
        <Tab
          text={"Billing Report"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        <Tab
          text={"Patient Engagement Metrics"}
          callBack={() => {
            setCurrentTab(2);
          }}
          active={currentTab === 2}
        />
        <Tab
          text={"Behavioral Health Metrics"}
          callBack={() => {
            setCurrentTab(3);
          }}
          active={currentTab === 3}
        />
      </div>
    </div>
  );
};

export default TabSwitcherComponent;
